import { memo } from 'react'
import { useActions, useCanUndo, useTranslation } from '../../hooks'
import { Button, kbdStr } from '../primitives'

export const UndoButton = memo(function UndoButton() {
	const msg = useTranslation()
	const canUndo = useCanUndo()
	const actions = useActions()

	const undo = actions['undo']

	return (
		<Button
			data-wd="main.undo"
			icon={undo.icon}
			title={`${msg(undo.label!)} ${kbdStr(undo.kbd!)}`}
			disabled={!canUndo}
			onClick={undo.onSelect}
			smallIcon
		/>
	)
})
